import { PANCHANG_COPY } from "./Panchang.copy";

export default function PanchangHeader({
  isHindi,
  todayFormatted,
  locationName,
}: {
  isHindi: boolean;
  todayFormatted: string;
  locationName: string;
}) {
  const copy = PANCHANG_COPY[isHindi ? "hi" : "en"];

  return (
    <div className="text-center mb-10">
      <p className="text-[11px] font-semibold uppercase tracking-[0.25em] mb-3 text-ish-accent">
        {copy.eyebrow}
      </p>
      <h1 className="text-[36px] sm:text-[40px] font-bold leading-tight text-ish-dark font-serif">
        {copy.headline}
      </h1>
      <p className="mt-2 text-[14px] text-ish-muted">{todayFormatted}</p>
      <p className="mt-1 text-[12px] text-ish-faint">
        {isHindi
          ? `तिथि, नक्षत्र, योग, करण और राहु काल — ${locationName} के लिए`
          : `Tithi, Nakshatra, Yoga, Karana & Rahu Kaal for ${locationName}`}
      </p>
      <div className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-medium text-ish-faint">
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
          </svg>
          {isHindi ? "सटीक वैदिक गणना" : "Accurate Vedic calculations"}
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
          {isHindi ? "प्रतिदिन अद्यतन" : "Updated Daily"}
        </span>
        <span className="flex items-center gap-1.5">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
          {isHindi ? "100% निःशुल्क" : "100% Free"}
        </span>
      </div>
    </div>
  );
}
